import { render, staticRenderFns } from "./SdsBulkOperationsDialog.vue?vue&type=template&id=6810e97e"
import script from "./SdsBulkOperationsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsBulkOperationsDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports